import React, { useState } from "react";
import { Link } from "react-router-dom";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { MdSearch } from "react-icons/md";
import Button from "react-bootstrap/Button";
import ExploreMarketPlaceModal from "../../Components/ExploreMarketPlaceModal/ExploreMarketPlaceModal";
import { toast } from "react-toastify";
import SearchBarResults from "../../Components/Search/SearchBarResults";

const ExploreMarketplace = ({
  ExploreMarketplaceData,
  MarketMembershipAPIFuc,
  SearchAPIFuc,
  CheckEligibility,
}) => {
  //read More
  const [readMore, setreadMore] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [indexValue, setIndexValue] = useState("");
  const [cityId, setCityId] = useState("");

  const SearchChange = (e) => {
    let SearchVal = e.target.value;
    setSearchValue(SearchVal.trim());
    if (!SearchVal) {
      SearchAPIFuc();
    }
  };

  const ReadmoreHandler = (i) => {
    setreadMore(!readMore);
    setIndexValue(i);
  };

  const SearchHandler = () => {
    SearchAPIFuc(searchValue);
  };

  const SearchEnterHandler = (e) => {
    if (e.key === "Enter") {
      SearchAPIFuc(searchValue);
    }
  };

  const SelectedCity = (CityId) => {
    setCityId(CityId);
  };

  const ApplyHandler = (CityID) => {
    if (CheckEligibility === true) {
      setModalOpen(true);
      SelectedCity(CityID);
    } else {
      toast.error(
        "Hey, you have exceeded the Apply to marketplace limit. Upgrade your subscription to apply to more marketplaces. Kindly refer to subscription page",
        {
          position: "top-center",
          autoClose: 10000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        }
      );
    }
  };

  //modal
  const [modalOpen, setModalOpen] = React.useState(false);
  return (
    <>
      <div className="manage-vou-main pt-3 pb-3">
        <p className="page-maintitle pt-2 orange-text">Explore Marketplace</p>
        <div className="manage-vou">
          <InputGroup className="search-bar">
            <InputGroup.Text>
              <MdSearch />
              <Form.Control
                type="text"
                placeholder="Search"
                maxLength={20}
                onChange={SearchChange}
                onKeyDown={SearchEnterHandler}
              />
            </InputGroup.Text>
            <Form.Control />
            <Button onClick={SearchHandler} variant="outline-secondary">
              Search
            </Button>
          </InputGroup>
        </div>
      </div>
      <SearchBarResults SearchValue={searchValue} />
      <div className="table-responsive-xl black-header text-center">
        <table className="recentact-table mt-3 table ver-middle manage-vou-table extra-explore-table">
          <thead>
            <tr>
              <th width="200px">Marketplace</th>
              {/* <th>Description</th> */}
              <th width="200px">Actions</th>
            </tr>
          </thead>
          <tbody>
            {ExploreMarketplaceData?.length != 0 ? (
              ExploreMarketplaceData?.map((data, index) => {
                let Description1 = data.description.substring(0, 200);

                {
                  /* let Description2 = data.description.substring(
                  200,
                  data.description.length
                ); */
                }

                const extraContentRead = (
                  <div>
                    <p className="extra-content">{data?.description}</p>
                  </div>
                );

                const linkNameRead =
                  indexValue === index && readMore ? "Read Less" : "Read More";

                return (
                  <tr>
                    <td title={data.market_place}>
                      <a
                        href={data.mms_url}
                        target="_blank"
                        className="marketplace-name text-limit-2 blue-underline-text"
                      >
                        {data.market_place}
                      </a>
                      <p className="vou-about mb-3 text-left pt-3">
                        <p>
                          {indexValue === index && readMore
                            ? ""
                            : Description1?.length > 199
                            ? Description1 + "..."
                            : Description1}
                        </p>
                        {indexValue === index
                          ? readMore && extraContentRead
                          : ""}
                        <span
                          style={{ cursor: "pointer !important" }}
                          className="read-more-link mb-2"
                          onClick={() => {
                            ReadmoreHandler(index);
                          }}
                        >
                          {Description1?.length > 199 ? linkNameRead : ""}
                        </span>
                      </p>
                    </td>
                    {data.applied_status === false ? (
                      <td>
                        <Link
                          className="unsubscribe-btn"
                          onClick={() => ApplyHandler(data.city_id)}
                        >
                          Apply
                        </Link>
                      </td>
                    ) : (
                      <td>
                        <Button className="applied-btn" disabled={true}>
                          Applied
                        </Button>
                      </td>
                    )}
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={3} className="text-center">
                  <p className="no-record">No records available!!</p>
                </td>
              </tr>
            )}

            {/* <tr>
              <td
                className="text-center text-limit-2 blue-underline-text"
                title="Kirkland, WA Kirkland, WA"
              >
                <Link to="">Kirkland, WA</Link>
              </td>
              <td>
                <p className="vou-about mb-3 text-left pt-3">
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Etiam eu turpis molestie, dictum est a, mattis tellus. Sed
                    dignissim, metus nec fringilla accumsan, risus sem
                    sollicitudin lacus, ut interdum tellus elit sed risus.
                    Maecenas eget condimentum velit, sit amet feugiat lectus.{" "}
                    <span
                      className="read-more-link mb-2"
                      onClick={() => {
                        setreadMore(!readMore);
                      }}
                    >
                      {linkNameRead}
                    </span>
                  </p>
                  {readMore && extraContentRead}
                </p>
              </td>
              <td>
                <Link className="unsubscribe-btn">Apply</Link>
              </td>
            </tr>
            <tr>
              <td
                className="text-center text-limit-2 blue-underline-text"
                title="Kirkland, WA Kirkland, WA"
              >
                <Link to="">Kirkland, WA</Link>
              </td>
              <td>
                <p className="vou-about mb-3 text-left pt-3">
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Etiam eu turpis molestie, dictum est a, mattis tellus. Sed
                    dignissim, metus nec fringilla accumsan, risus sem
                    sollicitudin lacus, ut interdum tellus elit sed risus.
                    Maecenas eget condimentum velit, sit amet feugiat lectus.{" "}
                    <span
                      className="read-more-link mb-2"
                      onClick={() => {
                        setreadMore(!readMore);
                      }}
                    >
                      {linkNameRead}
                    </span>
                  </p>
                  {readMore && extraContentRead}
                </p>
              </td>
              <td>
                <Link className="unsubscribe-btn">Apply</Link>
              </td>
            </tr>
            <tr>
              <td
                className="text-center text-limit-2 blue-underline-text"
                title="Kirkland, WA Kirkland, WA"
              >
                <Link to="">Kirkland, WA</Link>
              </td>
              <td>
                <p className="vou-about mb-3 text-left pt-3">
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Etiam eu turpis molestie, dictum est a, mattis tellus. Sed
                    dignissim, metus nec fringilla accumsan, risus sem
                    sollicitudin lacus, ut interdum tellus elit sed risus.
                    Maecenas eget condimentum velit, sit amet feugiat lectus.{" "}
                    <span
                      className="read-more-link mb-2"
                      onClick={() => {
                        setreadMore(!readMore);
                      }}
                    >
                      {linkNameRead}
                    </span>
                  </p>
                  {readMore && extraContentRead}
                </p>
              </td>
              <td>
                <Link className="unsubscribe-btn">Apply</Link>
              </td>
            </tr> */}
          </tbody>
        </table>
      </div>
      <ExploreMarketPlaceModal
        classN="ExploreModalClass green-btn mt-3"
        show={modalOpen}
        cityId={cityId}
        onHide={() => setModalOpen(false)}
        closeModelFuc={setModalOpen}
        ApiCallFuc={SearchAPIFuc}
        MarketMembershipAPICallFuc={MarketMembershipAPIFuc}
      />
    </>
  );
};

export default ExploreMarketplace;
